<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期" :wrapper-col="{ span: 21 }">
        <a-row>
          <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]" @change="effectiveDateChange" />
          <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled placeholder="结束日期" v-model="applicantInfoExpireDate" />
        </a-row>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业名称">
            <a-input :disabled="disabledAll" v-model="applicantInfo.name" @blur="queryCompanyCodeByName" v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" placeholder="请输入投保企业名称"></a-input>
          </a-form-item>
        </a-col>
          <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }],
                },
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input
								:disabled="true"
								v-model="applicantInfo.idNumber"
								v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [{ required: true, message: '请输入投保企业证件号码' }],
									},
								]"
								placeholder="请输入投保企业证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业经营范围">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.postCode"
              v-decorator="[
                'applicantInfo.postCode',
                {
                  rules: [{ required: true, message: '请输入投保企业经营范围' }],
                },
              ]"
              placeholder="请输入投保企业经营范围"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业地址">
            <a-cascader
              :disabled="disabledAll"
              placeholder="请选择"
              style="width: 293px"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }],
                },
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="详细地址" style="margin-left: 10px">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.address"
              v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }],
                },
              ]"
              placeholder="请输入联系地址"
              style="width: 294px"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsname"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsphone"
              v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' },
                  ],
                },
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.email"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' },
                  ],
                },
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'payMethod')"
              @blur="value => $tools.yaJinTip(value)"
              placeholder="请选择支付方式"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付方式' }],
                },
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <salInsuredList :effectiveDate="applicantInfo.effectiveDate" :disabledAll="disabledAll" :columns="columns" :data="data" @delSelect="delSelectpre" @addSelect="addSelectpre" @EduitSelect="EduitSelect"></salInsuredList>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
          <a-button :disabled="disabledAll" class="btn_color" type="primary" @click="changePremium"> 修改保费 </a-button>
        </a-form-item>
      </a-row>

      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已详细阅读
          <fileView></fileView>，对各项保险责任、除外责任、保险人被保险人权利义务等条款内容均已了解并同意投保。
        </a-checkbox>
      </a-row>
      <a-row class="order">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmit">保存订单</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="fastInsure"> 立即投保 </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">编辑</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div>
        请输入职业保费(如不输入则按原值({{ personBasePremium }})计算)：
        <a-input-number class="level_" :min="parseFloat(personBasePremium)" v-model="personAddPremium" />
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p style="text-align: center; font-size: 18px; margin-bottom: 0; padding: 20px; line-height: 30px">
        您投保的{{ productName() }}需支付保费 <span style="color: #fe8f2d; font-weight: bold"> {{ applicantInfo.totalPremium }} </span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from 'moment';
import salInsuredList from './salInsuredList';
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
let DATA = require('../data').default;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    salInsuredList,
  },
  mixins: [policyMixin, idNumberMixins],
  data() {
    //这里存放数据
    return {
      disabledAll: false,
      yueduBtn: false, //阅读中
      submitLoad1: false, //保存中
      submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      companyPropertyList: DATA.companyPropertyList,
      cunxuTimeList: DATA.cunxuTimeList, //存续时间
      /**需要的数据开始 */
      applicantInfo: {
        name: '', //投保企业名称
        idType: '', //证件类型
        idNumber: '', //证件号码
        imageUrl: '', //证件图片
        pacCode: '', //省市区
        address: '', //详细地址
        enttypecode: '', //企业性质
        expirationDate: '', //存续时间
        industrycode: [], //行业类别
        contactsname: '', //联系人名称
        postCode: '', //经营范围
        contactsphone: '', //联系人电话
        email: '', // 邮箱
        // beneficiary: "", // 附加被保险人
        remark: '', //备注
        invoiceprinttype: '01', //发票类型
        taxpayercertificateno: '', //纳税人识别号
        payMethod: '', //支付方式
        totalPremium: 0, //总保费
        juvenilesAvgpremuim: 0, //单个保费
        expireDate: '',
        effectiveDate: '', //投保期限
      },
      address: '',
      personBasePremium: 0,
      personPremium: 0,
      personAddPremium: 0,
      //表格的头部
      columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'num' },
        },
        {
          title: '姓名',
          dataIndex: 'name',
        },
        {
          title: '证件类型',
          dataIndex: 'idType',
          key: 'idType',
          scopedSlots: { customRender: 'idType' },
        },
        {
          title: '证件号码',
          dataIndex: 'idNumber',
        },
        {
          title: '出生日期',
          dataIndex: 'birthDate',
        },
        {
          title: '性别',
          dataIndex: 'gender',
          key: 'gender',
          scopedSlots: { customRender: 'gender' },
        },
        {
          title: '职业代码',
          dataIndex: 'occupationCode',
        },
        {
          title: '职业名称',
          dataIndex: 'occupationName',
        },
        // {
        //   title: "职业类别",
        //   dataIndex: "occulevel",
        //   scopedSlots: { customRender: "occulevel" }
        // }
      ],
      //表格的数据
      data: [],
      industrycodeTEXT: '', //四级行业的文本
      occuLevelSingalPrem: {}, //险种类
      //投保人证件类型
      companyIdTypeOptions: DATA.companyIdTypeOptions,
      //投保的天数
      guarantPre: DATA.guarantPre,
      loading: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      RiskInfos: {
        riskInfos: [],
        salPolicyExt: {
          isworkheightinvolved: 2,
        },
        salPolicy: {
          productCode: '', //产品code
          bracket: '1', //保费期限
          planCode: 'BABJ1',
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2, //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [], //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      ContentViewEduit: {}, //修改的保费
      creator: '1',
      productCode: '',
      plan: '',
      userParams: '',
      /**需要的数据结束 */
      guapre: '1',
      mon: '12',
      baodanData: {
        startdata: '',
      },
      startValues: null,
      typeNumObj: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
      },
      orderContent: {},
      AGE: 65,
      prohibitedIndustries: ['劳务', '人力资源', '职业介绍', '人才服务', '人才介绍', '企业咨询']
    };
  },
  //监听属性 类似于data概念
  computed: {
    addressOptions() {
      let twoArrCode = '';
      let dataArr = window.addrescode;
      dataArr.forEach(e => {
        if (twoArrCode.indexOf(e.text) > -1) {
          e['disabled'] = true;
        }  
        e.children.forEach(es => {
            if (es) delete es.children
          })
      });
      dataArr  = dataArr.filter(item => item.value == 31)
      return dataArr;
    },
    applicantInfoExpireDate() {
      let mon = 12;
      let date = this.applicantInfo.effectiveDate;
      let t2;
      if (date && mon) {
        t2 = moment(date).add(mon, 'months').subtract(1, 's');
      }
      return t2;
    },
  },
  //监控data中的数据变化
  watch: {
    'applicantInfo.pacCode'(val) {
      sessionStorage.removeItem('pacCode');
      sessionStorage.setItem('pacCode', val[1].value || null);
    },
    'applicantInfo.name'(val) {
      this.prohibitedIndustries.every(element => {
        if (val.indexOf(element) != -1) {
          this.$message.error(`投保人名称包含以下关键字拒保：劳务、人力资源、职业介绍、人才服务、人才介绍、企业咨询`);
          this.form.setFieldsValue({
            applicantInfo: { name: '' }
          });
          this.form2.setFieldsValue({
            name: ''
          });
          return false;
        } else {
          this.form.setFieldsValue({
            applicantInfo: {
              name: val
            }
          });
          return true;
        }
      });
    }
  },
  //方法集合
  methods: {
    moment,
    productName() {
      return sessionStorage.getItem('productName')
    },
    //理解并阅读
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    gonOne() {
      this.disabledAll = false;
      this.$bus.$emit('disabledBus', false);
      this.$router.push({
        name: 'sdgzbjhy',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          planCode: this.$route.query.planCode,
        },
      });
    },
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[1]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          if(!addressOptions) {
            return
          }
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0].children && oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          var threeArr = twoArr[0].children && twoArr[0].children.filter(item => arr[2] == item[str]) || [];
          sessionStorage.setItem('pacCode', twoArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0],threeArr[0]],
        };
      }
    },
    //打开文件列表
    fileListClick() {
      this.$store.commit('setNotShow', true);
    },
    //判断是否有多种类别
    checkBaseList(list) {
      return list.filter(e => e.personNum > 0).length > 0;
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId,
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            // 
            this.orderContent = res.data.content;
            this.$bus.$emit('busRiskInfos', this.orderContent);
            this.$store.commit('setOrderContent', this.orderContent);
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.data = res.data.content.salInsuredList;
              this.data.forEach((element, i) => {
                let str = element.birthDate;
                element['index'] = i + 1;
                element['relationship'] = 9;
                if(str.indexOf('-') === -1) {
                  element.birthDate = str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6, 8);
                }
              });
              this.RiskInfos.premiumBaseDtoList = this.numResultHolder(this.data).holderlist;
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.policyId = salPolicy.id.toString();
              this.plan = salPolicy.planCode;
              this.applicantInfo.mon = salPolicy.bracket;
              this.mon = salPolicy.bracket;
              this.applicantInfo.juvenilesAvgpremuim = salPolicy.juvenilesAvgpremuim;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              this.$store.commit('setproductCode', this.productCode);
              let effectiveDate;
              if (this.$route.query.xb) {
                //续保情况下时间处理
                effectiveDate = moment(salPolicy.expireDate).add(1, 'days');
              } else {
                effectiveDate = moment(salPolicy.effectiveDate);
              }
              this.applicantInfo.effectiveDate = moment(effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(effectiveDate).format('YYYY-MM-DD'),
                },
                baodanData: {
                  startdata: moment(effectiveDate).format('YYYY-MM-DD'),
                },
              });
            }
            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              this.applicantInfo.name = res.data.content.salPolicyHolder.name;
              this.applicantInfo.invoiceprinttype = salPolicyHolder.invoiceprinttype;
              this.applicantInfo.taxpayercertificateno = salPolicyHolder.taxpayercertificatetype;
              this.applicantInfo.pacCode = this.filterPcode(salPolicyHolder.addresscode&&salPolicyHolder.addresscode.split('-')|| []).arrCode;
              this.address = salPolicyHolder.address;
              sessionStorage.setItem('pacCode', salPolicyHolder.city);
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  pacCode: this.filterPcode(salPolicyHolder.addresscode&&salPolicyHolder.addresscode.split('-') || []).code,
                },
              });
            }
            
            if (res.data.content.salPolicyHolderExt) {
              let salPolicyHolderExt = res.data.content.salPolicyHolderExt;
              this.industrycodeTEXT = salPolicyHolderExt.industryname;
            }
            if (res.data.content.salPolicyExt) {
              let salPolicyExt = res.data.content.salPolicyExt;
              this.RiskInfos.salPolicyExt.occEmpVersion = salPolicyExt.occEmpVersion;
              this.RiskInfos.salPolicyExt.isworkheightinvolved = salPolicyExt.isworkheightinvolved;
            }
            
            this.data = res.data.content.salInsuredList;
            this.RiskInfos.salPolicy = { ...this.RiskInfos.salPolicy, ...res.data.content.salPolicy };
            this.RiskInfos.salPolicyHolder = { ...this.RiskInfos.salPolicyHolder, ...res.data.content.salPolicyHolder };
            this.RiskInfos.salPolicyHolder.addfifty = '1';
            this.applicantInfo.totalPremium = this.orderContent.salPolicy.totalPremium; //总保费
            this.resultPremiumSum(this.RiskInfos);
          }
        }
      });
    },
    //修改保费
    changePremium() {
      if (JSON.stringify(this.CScontent) == '{}') {
        this.$message.error('您还没有计算保费');
        return;
      }
      this.modalVisible = true;
    },
    // 选的总投保人数
    totalNumber() {
      let _DATA = this.$lodash.cloneDeep(this.data);
      let copyd = _DATA.filter(e => +e.occulevel.slice(0, 1));
      let num1_4 = copyd.filter(e => e.occulevel < 5).length;
      let num5_6 = copyd.filter(e => e.occulevel > 4).length;
      return {
        allNumber: parseInt(num1_4 + num5_6),
        num1_4,
        num5_6,
      };
    },
    //确认修改
    handleOk() {
      this.resultPremiumSum(this.RiskInfos, 'add');
    },
    //拼接险种
    flightNumberFun(arr) {
      let strArr = [];
      arr.forEach(e => {
        if (e.amount == 0) {
          strArr.push(e.riskCode);
        }
      });
      return strArr.join(',');
    },
    //统计次数和拼接试算类别数据
    numResultHolder(data) {
      
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0,
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      return {
        holderlist: d,
        holderNum: b,
      };
    },
    //提交的去重
    unique(arr, attribute) {
      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
          //  -1代表没有找到
          new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(arr[i]);
        }
      }
      return json_arr;
    },
    //过滤人员列表
    filterSalInsuredList(data) {
      let DATA = this.$lodash.cloneDeep(data);
      DATA.forEach(e => {
        if (e['gender'] == '男' || e['gender'] == 'M') {
          e['gender'] = 'M';
        } else {
          e['gender'] = 'F';
        }
        e['relationship'] = 9;
        e['occulevel'] = e.occulevel.toString().slice(0, 1);
        return e.occulevel;
      });
      return DATA;
    },
    //试算的接口
    resultPremiumSum(data, type) {
      let copyData = this.$lodash.cloneDeep(data);
      let formData = {
        riskInfos: copyData.riskInfos, //险种信息
        salPolicy: {
          planCode: copyData.salPolicy.planCode, //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
          creator: this.creator,
          bracket: this.mon, //
          flightnumber: this.flightNumberFun(copyData.riskInfos), // 另加的拼接险种的字段
        },
        salPolicyExt: {
          isworkheightinvolved: copyData.salPolicyExt.isworkheightinvolved,
          occEmpVersion: this.fileCodeContent.id,
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: copyData.salPolicyHolder.stature, //是否高空（2-否，1-是）
          name: this.applicantInfo.name,
        },
        premiumBaseDtoList: copyData.premiumBaseDtoList, //人数
      };
      if (type == 'add') {
        formData.salPolicyHolder.addfifty = '3';
        formData.salPolicyHolder.gztypestr = this.personAddPremium;
      }
      this.$api.calPremiumEmployer(formData).then(res => {
        if (res.data.success) {
          let datas = res.data.content;
          this.modalVisible = false
          if (type != 'eduit') {
            this.applicantInfo.totalPremium = datas.totalPremium;
            this.personBasePremium = datas.personBasePremium;
            this.personPremium = datas.personPremium
          }
        } else {
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
    // 根据人数计算保费
    countTotalPremium(data) {
      let totalPremium = 0;
      this.data.forEach(element => {
        let premium = data[element.occupationCode];
        element.premium = premium;
        totalPremium += premium;
      });
      this.applicantInfo.totalPremium = totalPremium;
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.applicantInfo.invoiceprinttype = value;
    },
    //选择天数的
    onChangemon(e) {
      this.mon = e.target.value;
      this.RiskInfos.salPolicy.bracket = this.mon;
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
      if (this.applicantInfo.effectiveDate) {
        let end = moment(this.applicantInfoExpireDate).add(this.mon, 'month').subtract(1, 'days');
        this.form.setFieldsValue({ expireDate: end });
      }
      this.resultPremiumSum(this.RiskInfos);
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date;
    },
    //开始时间
    disabledDate(current) {
      return (current && current < moment().endOf('day')) || current > moment().add(30, 'day');
    },
    //修改
    EduitSelect(data) {
      
      this.data.forEach((e, i) => {
        if (i == data.eduitIndex) {
          this.data[i] = data;
        }
      });
      this.RiskInfos.premiumBaseDtoList = this.numResultHolder(this.data).holderlist;
      this.resultPremiumSum(this.RiskInfos);
      
    },
    //粘贴
    addSelectpre(data) {
      if (Array.isArray(data)) {
        var datas = data;
        this.data.push(...datas);
      } else {
        this.data.push(data);
      }
      let cesiData = this.$lodash.cloneDeep(this.data);
      this.data = this.unique(this.data, 'idNumber');
      if (cesiData.length != this.data.length) {
        this.$message.warning('受保人有重复，已做删除');
      }
      
      this.RiskInfos.premiumBaseDtoList = this.numResultHolder(this.data).holderlist;
      this.resultPremiumSum(this.RiskInfos);
    },
    //批量删除
    delSelectpre(data) {
      this.data = data;
      let cesiData = this.$lodash.cloneDeep(this.data);
      this.data = this.unique(this.data, 'idNumber');
      if (cesiData.length != this.data.length) {
        this.$message.warning('受保人有重复，已做删除');
      }
      this.RiskInfos.premiumBaseDtoList = this.numResultHolder(this.data).holderlist;
      if (this.data.length) {
        this.resultPremiumSum(this.RiskInfos);
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    },
    //最后的提交
    handleSubmit() {
      
      let ageStatus = true;
      this.data.forEach(e => {
        if (e.idType == '1') {
          if (!this.$regTest.checkIdCard(e.idNumber)) {
            this.$message.error(`投保人${e.idNumber}的身份证有误，请修改后再试！`);
            ageStatus = false;
            return;
          }
        }
        let age = this.$tools.jsGetAge(e.birthDate, moment(this.applicantInfo.effectiveDate).format('YYYY-MM-DD'));
        if (age < 16 || age > this.AGE) {
          this.$message.error(`投保人年龄仅限于16-${this.AGE}周岁，请修改后再试！`);
          ageStatus = false;
          return;
        }
      });
      if (!ageStatus) {
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          let base = this.applicantInfo;

          let data = {
            salInsuredList: this.filterSalInsuredList(this.data), //表格的数据
            salPolicy: {
              //保单信息
              planCode: this.RiskInfos.salPolicy.planCode, //产品计划 （固定值ConstructAccident）
              productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
              creator: this.creator,
              id: this.policyId,
              effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime  保单生效时间
              expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
              payMethod: values.applicantInfo.payMethod, //支付方式”
              bracket: this.RiskInfos.salPolicy.bracket, //页面选择的保障期间（几个月就传几，整数）
              totalPremium: base.totalPremium, //totalPremium  总保费
              coverageamount: '', //totalSumInsured  总保额
              remark: values.applicantInfo.remark, //备注
              ordertraceno: '', //"凭证支付时的凭证号",
              flightnumber: this.flightNumberFun(this.RiskInfos.riskInfos), // 另加的拼接险种的字段
            },
            salPolicyExt: {
              occEmpVersion: this.fileCodeContent.id,
              isworkheightinvolved: this.RiskInfos.salPolicyExt.isworkheightinvolved,
            },
            salPolicyHolder: {
              //投保人信息
              addfifty: '2', //测算类型
              type: 'C', //固定值
              name: values.applicantInfo.name, //name  投保人名称
              idType: values.applicantInfo.idType, //证件类型
              idNumber: values.applicantInfo.idNumber, //certNo   证件号码
              address: values.applicantInfo.address, //详细地址
              enttypecode: values.applicantInfo.enttypecode, //企业性质
              expirationDate: values.applicantInfo.expirationDate, //存续时间
              contactsname: values.applicantInfo.contactsname, //联系人姓名
              postCode: values.applicantInfo.postCode, //经营范围
              contactsphone: values.applicantInfo.contactsphone, //联系人电话
              telephone: values.applicantInfo.contactsphone, //联系人电话
              email: values.applicantInfo.email, //联系人邮箱
              pacCode: values.applicantInfo.pacCode, //地区code
              province: base.pacCode[0].text, //省
              city: base.pacCode[1].text, //市
              district: '', //区
              projectaddress: `${base.pacCode[0].text}&&${base.pacCode[1].text}&&${values.applicantInfo.address}`,
              projectarea: `${base.pacCode[0].value}-${base.pacCode[1].value}`,
              addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}`,
              stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
              invoiceprinttype: values.applicantInfo.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
              taxpayercertificatetype: values.applicantInfo.invoiceprinttype == '01' ? values.applicantInfo.taxpayercertificateno : '01',
              gztypestr: this.personPremium,
            },
            salPolicyHolderExt: {
              industryname: this.industrycodeTEXT,
            },
            riskInfos: this.RiskInfos.riskInfos.filter(item => item.amount != -1),
          };
          
          this.postPolicyData = data;
          // return
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          this.submitLoad1 = true;
          this.axiosPolicy(); // 保存订单是 直接保存
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    axiosPolicy() {
      //提交保单
      this.$store.commit('setLoading', { show: true, text: '保存中...' });
      this.$api
        .employerPolicy(this.postPolicyData)
        .then(res => {
          if (res.data.returnCode == '00') {
            this.showPaySure = false;
            this.policyId = res.data.content;
            this.$message.success('保存成功！');
            this.$router.push({
              name: 'sdgzbjhy',
              query: {
                u: this.$route.query.u,
                p: this.$route.query.p,
                sign: this.$route.query.sign,
                policyId: this.policyId,
                planCode: this.$route.query.planCode,
                continuation: '1'
              },
            });
            this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
          this.submitLoad1 = false;
        });
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: 'sdgzbjhy', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
      });
    },
    handleChange(value, type, label) {
      if (type == 'idType') {
        this.queryCompanyCodeByName();
      }
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
        this.address = label.length > 1 ? label[0].text + label[1].text : '';
        sessionStorage.setItem('pacCode', value[1]);
      } else {
        this.applicantInfo[type] = value;
      }
    },
    queryCompanyCodeByName() {
      this.$nextTick(() => {
        this.queryCompanyIdNumber(this.applicantInfo.name, this.applicantInfo.idType, this.companyIdTypeOptions);
      })
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$bus.$on('onRiskInfos', data => {
      let strdata = this.$lodash.cloneDeep(data);
      this.RiskInfos.riskInfos = strdata.riskInfos;
      this.RiskInfos.salPolicy = strdata.salPolicy;
      this.RiskInfos.salPolicyExt = strdata.salPolicyExt;
      this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
      this.mon = strdata.salPolicy.bracket;
      if (this.data.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
    });
    this.$bus.$on('selectCS', data => {
      this.AGE = data;
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    this.$bus.$off('onRiskInfos');
    this.$bus.$off('resultPcontent');
    this.$bus.$off('selectCS');
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}
</style>
